import { useState } from "react";
import { Mail, Send } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { Reveal } from "../components/motion";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/contact", form);
      toast.success("Message sent! We'll get back to you soon.");
      setForm({ name: "", email: "", message: "" });
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setSending(false);
    }
  };

  const inputCls = "w-full rounded-2xl border border-blush bg-cream px-5 py-3.5 text-sm text-navy placeholder:text-navy/35 focus:border-pink focus:outline-none";

  return (
    <div className="bg-cream" data-testid="contact-page">
      <div className="mx-auto grid max-w-6xl gap-14 px-6 py-16 lg:grid-cols-2 lg:py-24">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-pinkdeep">Contact</p>
          <h1 className="mt-4 font-display text-4xl font-medium text-navy sm:text-5xl">Say goodnight — or just say hi.</h1>
          <p className="mt-5 max-w-md text-base leading-relaxed text-navy/60">
            Questions about a Buddy, an order, or the perfect match for your little one? We read everything.
          </p>
          <div className="mt-8 flex items-center gap-3 text-navy/70">
            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-blush text-pinkdeep"><Mail size={18} /></span>
            <span className="text-sm font-semibold">hello@bedtimebuddies.com</span>
          </div>
          <img src="/assets/buddy_honey.png" alt="Honey the Bear" className="mt-10 w-64 rounded-[2rem] object-cover shadow-[0_16px_50px_rgba(16,42,86,0.10)]" />
        </Reveal>
        <Reveal delay={0.1}>
          <form onSubmit={submit} className="space-y-4 rounded-[2rem] bg-white p-8 shadow-[0_16px_50px_rgba(16,42,86,0.08)]" data-testid="contact-form">
            <input required placeholder="Your name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
              aria-label="Your name" data-testid="contact-name" className={inputCls} />
            <input required type="email" placeholder="Your email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
              aria-label="Your email" data-testid="contact-email" className={inputCls} />
            <textarea required rows={6} placeholder="How can we help?" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })}
              aria-label="Your message" data-testid="contact-message" className={inputCls} />
            <button type="submit" disabled={sending} data-testid="contact-submit"
              className="flex w-full items-center justify-center gap-2 rounded-full bg-pink py-4 font-display font-semibold tracking-wide text-navy transition hover:bg-moon disabled:opacity-50">
              <Send size={16} /> {sending ? "Sending…" : "SEND MESSAGE"}
            </button>
          </form>
        </Reveal>
      </div>
    </div>
  );
}
